import { SensorsOff } from '@mui/icons-material';
import * as React from 'react';
import { colours } from 'utils/constants';
import { containerStyle } from 'utils/styles';

export function SensorUpsellBanner(props: { sensorType: string; hook: string }) {
  const { sensorType, hook } = props;

  return (
    <div style={containerStyle}>
      <div style={{ textAlign: 'center', marginBottom: 10 }}>
        <SensorsOff style={{ color: colours.warmGrey, fontSize: '66px' }} />
        <h4 style={{ color: colours.warmGrey }}>No {sensorType} sensors</h4>
        <br />
        {hook}
        <br />
        We can set you up with some {sensorType} sensors.
        <br />
        <a
          href="mailto:support@b-line.io?subject=Interested%20in%20space%20analytics"
          style={{ color: colours.seafoam }}
        >
          ✉️ Let us know!{' '}
        </a>
      </div>
    </div>
  );
}
